import { useQuery } from '@tanstack/react-query'

import { adminHiresApi, type AdminHiresFilters } from '@/features/admin/api/hires.api'

export function useAdminHiresQuery(params: AdminHiresFilters & { page?: number; per_page?: number }) {
  return useQuery({
    queryKey: ['admin', 'hires', 'list', params],
    queryFn: () => adminHiresApi.list(params),
    placeholderData: (previous) => previous,
  })
}

export function useAdminHiresSummaryQuery(params: AdminHiresFilters) {
  return useQuery({
    queryKey: ['admin', 'hires', 'summary', params],
    queryFn: () => adminHiresApi.summary(params),
    placeholderData: (previous) => previous,
  })
}
